import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SaleItem } from '../../sale-item'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { Dictionary } from '@ngrx/entity'
import { Observable } from 'rxjs'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { SaleItemPriceDetails } from '../../sale-item.service'

@Component({
  selector: 'sale-item-price-details',
  templateUrl: './sale-item-price-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaleItemPriceDetailsComponent {
  @Input() saleItem: SaleItem

  public productEntities$: Observable<Dictionary<Product>>

  constructor(
    public configurationService: ConfigurationService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
  }

  public shouldShowPrimaryPriceLine(
    saleItemPriceDetails: SaleItemPriceDetails
  ): boolean {
    const shouldShowZeroBookerLine =
      this.saleItem?.params?.familyMembersInvited?.length > 0 &&
      (this.saleItem?.params?.bookerAssisting ?? true)

    return (
      (saleItemPriceDetails.qty > 0 &&
        saleItemPriceDetails.memberQty === 0 &&
        (saleItemPriceDetails.price > 0 || shouldShowZeroBookerLine)) ||
      (!saleItemPriceDetails.price &&
        !!saleItemPriceDetails.qty &&
        !this.saleItem.totalPrice &&
        !saleItemPriceDetails.memberPrice &&
        !saleItemPriceDetails.guestPrice &&
        !saleItemPriceDetails.otherPrice &&
        !saleItemPriceDetails.categoryQty)
    )
  }

  public shouldShowMemberPriceLine(
    saleItemPriceDetails: SaleItemPriceDetails
  ): boolean {
    const shouldShowZeroBookerLine =
      this.saleItem?.params?.familyMembersInvited?.length > 0 &&
      (this.saleItem?.params?.bookerAssisting ?? true)

    return (
      saleItemPriceDetails.memberQty > 0 &&
      (saleItemPriceDetails.memberPrice > 0 || shouldShowZeroBookerLine)
    )
  }
}
